module.exports = __webpack_public_path__ + "img/close.cb962673.svg";